(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram"] && !Shopify.designMode) return;
  try {
    
  	// Instagram feed
    var feed = new Instafeed({
      clientId: clientId,
      accessToken: accessToken,
      get: "user",
      userId: userId,
      limit:'6',
	  resolution: 'standard_resolution'
    });
    feed.run();

  } catch(e) { console.error(e); }
})();
})();
